<template>
  <div class="row align-items-start">
    <div class="col-12 col-md-4 align-items-start">
      <input-select-search
        ref="disciplinaCurriculoId"
        :label="'Disciplina'"
        :options="disciplinas"
        v-model="disciplina.disciplinaCurriculoId"
        required
      />
    </div>
    <div class="col-12 col-md-2">
      <input-text
        ref="faltas"
        v-model="disciplina.faltas"
        :label="'Faltas'"
        type="number"
      />
    </div>
    <div class="col-12 col-md-2">
      <input-text
        ref="cargaHoraria"
        v-model="disciplina.cargaHoraria"
        :label="'Carga Horária'"
        type="number"
      />
    </div>
    <div class="col-12 col-md-2">
      <input-text
        v-if="!isParecerDescritivo"
        ref="media"
        v-model="disciplina.media"
        :label="'Média'"
        type="number"
        :max="10"
      />
      <input-select
        v-else
        ref="statusParecerDescritivo"
        v-model="disciplina.statusParecerDescritivo"
        :label="'Situação'"
        :options="opcoesStatusParecerDescritivo"
        value-field="value"
        text-field="text"
      />
    </div>
    <div class="col-12 col-md-2 botao-acao-filtro align-items-start">
      <b-button variant="primary" @click="adicionar" class="mb-3 w-100">
        {{ $t('GERAL.ADICIONAR') }}
      </b-button>
    </div>
  </div>
</template>
<script>
// Utils & Aux:
import helpers from '@/common/utils/helpers';

// Components:
import { InputText, InputSelectSearch, InputSelect } from '@/components/inputs';

export default {
  props: {
    disciplinas: { type: Array, default: Array },
  },
  components: {
    InputText,
    InputSelectSearch,
    InputSelect,
  },
  data() {
    return {
      disciplina: {},
      opcoesStatusParecerDescritivo: [
        { value: 'APR', text: 'Aprovado' },
        { value: 'RPV', text: 'Reprovado' },
      ],
    };
  },
  computed: {
    isParecerDescritivo() {
      return this.disciplina.disciplinaCurriculoId === '17ebab43-5404-4963-9d37-2cad19464866';
    },
  },
  watch: {
    'disciplina.disciplinaCurriculoId'(newVal, oldVal) {
      // Limpa os campos quando trocar de disciplina
      if (newVal !== oldVal) {
        const isParecerDescritivo = newVal === '17ebab43-5404-4963-9d37-2cad19464866';
        if (isParecerDescritivo) {
          this.disciplina.statusParecerDescritivo = null;
          // Remove media se existir
          if (this.disciplina.media !== undefined) {
            delete this.disciplina.media;
          }
        } else {
          this.disciplina.media = null;
          // Remove statusParecerDescritivo se existir
          if (this.disciplina.statusParecerDescritivo !== undefined) {
            delete this.disciplina.statusParecerDescritivo;
          }
        }
      }
    },
  },
  methods: {
    // EMITINDO DADO PARA TABELA(ela que faz o CRUD da disciplina):
    adicionar() {
      if (!this.validarFormulario()) return;
      this.$emit('adicionar', this.disciplina);

      helpers.resetarValidacao(this.$refs);
      this.disciplina = {};
    },
    // FUNÇÕES AUXILIARES:
    validarFormulario() {
      return helpers.validarFormulario(this.$refs);
    },
  },
};
</script>

<style scoped></style>
